import { FC } from 'react'
import { Security } from '@okta/okta-react'
import { useNavigate } from 'react-router'
import { legacyTheme } from '@signifyd/ant'
import {
  AppConfigProvider,
  ErrorBoundary,
  useUserContext,
} from '@signifyd/components'
import { oktaAuth } from 'lib/auth/oktaAuth'
import AppRoutes from './AppRoutes'

const AppContainer: FC = () => {
  const { user, userConfigs } = useUserContext()

  const navigate = useNavigate()

  const restoreOriginalUri = (): void => {
    const redirect = localStorage.getItem('originalUrl') || '/playwright'

    void navigate(redirect)
  }

  return (
    <AppConfigProvider
      theme={legacyTheme}
      user={user}
      userConfigs={userConfigs}
    >
      <ErrorBoundary>
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <AppRoutes />
        </Security>
      </ErrorBoundary>
    </AppConfigProvider>
  )
}

export default AppContainer
